import moment from 'moment'
import { NGXLogger } from 'ngx-logger'
import { Observable } from 'rxjs'
import { mobileErrorMessage, validateNumber } from 'src/app/core/helpers/app-link'
import { LoanInfo, OfferInfo, PayOfferObject } from 'src/app/core/helpers/interfaces'
import { jsonDeclinedCoboOffer, jsonDeclinedCoboOfferCreditFreeze, jsonFullyApproved2Options,
  jsonPartiallyApproved, jsonWelcomeBackScreen } from 'src/app/core/helpers/loanInfoUtils'
import { ApiService } from 'src/app/core/services/api.service'
import { LoanOptionsService } from 'src/app/core/services/loan-options.service'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { PageNavigationService } from 'src/app/core/services/page-navigation.service'
import { SendAppLinkService } from 'src/app/core/services/send-app-link.service'
import { ModalTypes } from '../../../../core/helpers/modal-store'
import { ModalOptionsNavigation } from './modal-navigation'
import { OptionsStore, topNamings } from './options-store'
import { RequestHandler } from './request-handler'

// global important modal logic
export class OptionsLogic {

  store: OptionsStore
  requestHandler: RequestHandler
  navigation: ModalOptionsNavigation
  api: ApiService
  pageNavigationService: PageNavigationService
  modalStateService: ModalStateService
  loanOptionsService: LoanOptionsService
  sendAppLinkService: SendAppLinkService
  breakpoints: any
  logger: NGXLogger


  constructor(
    store: OptionsStore, requestHandler: RequestHandler, navigation: ModalOptionsNavigation
  ) {
    this.store = store
    this.requestHandler = requestHandler
    this.navigation = navigation

    this.api = requestHandler.api
    this.pageNavigationService = requestHandler.pageNavigationService
    this.modalStateService = requestHandler.modalStateService
    this.loanOptionsService = requestHandler.loanOptionsService
    this.sendAppLinkService = requestHandler.sendAppLinkService
    // this.notifier = requestHandler.notifier
    this.breakpoints = requestHandler.breakpoints
    this.logger = requestHandler.logger
  }

  /**
   * check navigation state;
   * on popstate open modal by saved type
   * @returns is popstate restore done
   */
  checkAndRestoreModal(): boolean {
    const prev = this.pageNavigationService.getPrevState()
    const current = this.pageNavigationService.getCurrentState()
    const isOpenNeeded = this.pageNavigationService.openNow
    if (!isOpenNeeded) {
      return false
    }
    // our case or restoring
    if (current && current.trigger === 'popstate') {
      const type = this.modalStateService.getFromLocalStorage('modalType')
      const loanInfo = this.modalStateService.getFromLocalStorage('loanInfo')
      this.logger.info(type)
      this.logger.info(loanInfo)
      this.openModalByType(type)
      return true
    }
    return false
  }

  /**
   * send app link on string
   */
  sendAppLinkNumber(numbr: string, that?: any): void {
    this.logger.info(numbr)
    if (!validateNumber(numbr)) {
      this.logger.info('send notify')
      // this.notifier.notify('error', mobileErrorMessage)
      return
    }
    that.toggleLoader(true)
    this.sendAppLinkService.sendAppLinkWrapper(null, numbr, null, false, that)
  }

  /**
   * if return from external link,
   * then open modal by saved type
   */
  checkAndRestoreExternal(): void {
    const extLink = this.modalStateService.getFromLocalStorage('externalLink')
    this.logger.info(extLink)
    if (extLink === 'true' && this.pageNavigationService.modalRestoreExternal) {
      const type = this.modalStateService.getFromLocalStorage('modalType')
      if (type) {
        this.pageNavigationService.modalRestoreExternal = false
        this.modalStateService.pushToLocalStorage('externalLink', 'false')
        this.openModalByType(type)
      }
    }
  }

  /**
   * just open modal by type, use navigation class
   */
  openModalByType(type: ModalTypes) {
    switch (type) {
      case ModalTypes.mainform:
        this.logger.info(ModalTypes.mainform)
        this.logger.info('already on mainform')
        break
      case ModalTypes.coapplicant:
        this.logger.info(ModalTypes.coapplicant)
        this.logger.info('need to switch on coapplicant')
        this.pageNavigationService.openNow = false
        this.navigation.setShowCoapplicant()
        break
      case ModalTypes.loanSelect:
        this.logger.info(ModalTypes.loanSelect)
        this.logger.info('need to switch on loan select')
        this.navigation.setShowSelectBlock()
        this.pageNavigationService.openNow = false
        break
      case ModalTypes.offer:
        this.logger.info(ModalTypes.offer)
        this.logger.info('need to switch on offer')
        this.navigation.setShowOfferBlock()
        this.pageNavigationService.openNow = false
        break
      case ModalTypes.exceptionFlow:
        this.logger.info(ModalTypes.exceptionFlow)
        this.logger.info('need to switch on exceptionFlow')
        this.navigation.setShowException()
        this.pageNavigationService.openNow = false
        break
      case ModalTypes.straightDecline:
        this.logger.info(ModalTypes.straightDecline)
        this.logger.info('need to switch on straightDecline')
        this.navigation.setShowDecline()
        this.pageNavigationService.openNow = false
        break
    }
  }

}
